import Detail from "./Detail";
import ManageProjects from "./ManageProjects";
import New from "./New";
import Settings from "./Settings";
import Wrapper from "./Wrapper";

export default {
  Detail,
  ManageProjects,
  New,
  Settings,
  Wrapper
};
